export default __webpack_public_path__ + "static/media/title-reportingIcon.1f83264a.svg";